<div class="login-container">
  <p-toast></p-toast>
  <p-card class="login-card">
    <app-logo></app-logo>
    <div class="language-selector">
      <app-select-language></app-select-language>
    </div>

    <div
      class="login-form"
      *ngIf="!isTwoFactorStage">
      <p class="login-instruction">{{ "UseLocalAccount" | translate }}</p>

      <div class="form-group">
        <span class="p-input-icon-left p-fluid">
          <input
            type="email"
            pInputText
            [(ngModel)]="username"
            placeholder="{{ 'EmailPlaceholder' | translate }}"
            class="form-input"
            autocomplete="username"
            [disabled]="isLoading" />
        </span>
      </div>

      <div class="form-group">
        <span class="p-input-icon-left p-fluid">
          <i class="pi pi-lock"></i>
          <p-password
            [(ngModel)]="password"
            [placeholder]="'PasswordPlaceholder' | translate"
            [feedback]="false"
            [toggleMask]="true"
            styleClass="w-full"
            inputStyleClass="form-input"
            autocomplete="current-password"
            [disabled]="isLoading"></p-password>
        </span>
      </div>

      <button
        pButton
        type="button"
        [label]="'LogIn' | translate"
        class="login-button p-button-secondary"
        (click)="onLogin()"
        pRipple
        [disabled]="!username || !password || isLoading"
        [loading]="isLoading"></button>


      @if (environment.client === 'masofa') {
        <div class="divider-container">
          <p-divider layout="horizontal">
            <span>{{ 'Or' | translate }}</span>
          </p-divider>
        </div>
        <button
          type="button"
          class="oneid-button"
          [disabled]="isLoading"
          (click)="onOneIdLogin()">
          <span class="oneid-logo">ONE</span>
          <span class="oneid-id">ID</span>
        </button>
      }


    </div>

    <div
      class="twofactor-form"
      *ngIf="isTwoFactorStage">
      <p class="login-instruction">
        {{ "TwoFactorCodeSentText" | translate }}
        <br />
        <small>{{ "CheckSpam" | translate }}</small>
      </p>

      <div class="form-group">
        <input
          type="text"
          maxlength="6"
          pInputText
          [(ngModel)]="twoFactorCode"
          placeholder="{{ 'EnterCodePlaceholder' | translate }}"
          class="form-input"
          autocomplete="one-time-code" />
      </div>

      <button
        pButton
        type="button"
        [label]="'ConfirmCode' | translate"
        class="login-button p-button-secondary"
        (click)="onConfirmTwoFactor()"
        [disabled]="!twoFactorCode || isLoading"
        [loading]="isLoading">
      </button>

      <p class="resend-section">
        <button
          pButton
          type="button"
          label="{{ 'ResendCode' | translate }}"
          class="p-button-text"
          (click)="onResendCode()"
          [disabled]="resendTimer > 0">
        </button>
        <span *ngIf="resendTimer > 0">({{ resendTimer }}s)</span>
      </p>

      <button
        pButton
        type="button"
        label="{{ 'Cancel' | translate }}"
        class="p-button-text"
        (click)="onCancelTwoFactor()">
      </button>
    </div>
  </p-card>
</div>
